import { InjectionToken, Provider, Type } from '@angular/core';

export type ProviderTypes<T> =
  | Type<T>
  // import { ValueSansProvider } from '@angular/core'
  | { useValue: T }
  // import { ClassSansProvider } from '@angular/core'
  | { useClass: Type<T> }
  // import { ConstructorSansProvider } from '@angular/core'
  | { deps?: any[] }
  // import { ExistingSansProvider } from '@angular/core'
  | { useExisting: Type<T> | InjectionToken<T> } // todo: add support for abstract classes
  // import { FactorySansProvider } from '@angular/core'
  | {
      useFactory: Function;
      deps?: any[];
    };

/**
 * Creates a new provider with the given provider and provides it under the given token.
 *
 * The provider can be either a value, a class, an existing value, or a factory.
 * If the provider's type is a Type, it is used as a useClass (default option).
 *
 * @param provide The token to provide.
 * @param provider The provider to use.
 * @param multi Whether to add the provider to the injector's providers array or not.
 * @returns The created provider object.
 */
export function provide<T>(provide: any, provider: ProviderTypes<T>, multi?: boolean): Provider {
  // If provider is Type<T> (function), we use it as a useClass (default option)
  if (typeof provider === 'function') {
    return {
      provide,
      useClass: provider,
      multi,
    };
  }

  return {
    ...provider,
    provide,
    multi,
  };
}
